<template lang="html">
  <div class="main">
    <SoundslidesPlayer
      v-if="$route.meta.exact"
      :path="path"
      :data-file="dataFile"
      :use-show-dimensions="true"
      :solo-player="true"
      :report-data-id="reporting_id"
      :report-data="true"
      class="center"
    />
    <SoundslidesPlayer
      v-if="$route.meta.fill"
      :path="path"
      :data-file="dataFile"
      :fillscreen="true"
      :solo-player="true"
      :report-data="true"
      :report-data-id="reporting_id"
    />
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer";
export default {
  name: "LegacyHostingPlayer",
  components: {
    SoundslidesPlayer
  },
  data() {
    return {};
  },
  computed: {
    reporting_id() {
      return this.$route.params.id;
    },
    dataFile() {
      var id = this.$route.params.id;
      if (id.length === 8 || id.length === 10) {
        // Soundslides 3.
        return "data.json";
      } else {
        // Legacy hosting is 5 digits.
        // New Hosting (for legacy shows) is 10 digits.
        return "soundslide.xml";
      }
    },
    path() {
      var id = this.$route.params.id;
      // Check for a private link.
      if (this.$route.params.private_id) {
        // Private link shows are very simple. The private_id is part of the url.
        // Add the private link below.
        var private_id = this.$route.params.private_id;
        return `https://cdn3.soundslides.com/json/${id}/${private_id}/`;
      }
      if (id.length === 8 || id.length === 10) {
        // Soundslides 3.
        // If new json, all the media endpoints are in the json file.
        // Just send in the path to the json.
        return `https://cdn3.soundslides.com/json/${id}/`;
      } else {
        // Legacy hosting is 5 digits.
        // New Hosting (for legacy shows) is 10 digits.
        return `https://hosting.soundslides.com/${id}/`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.center {
  position: relative;
  top: 33%;
  left: 50%;
  transform: translateX(-50%) translateY(-33%);
  max-width: 100%;
  max-height: 100%;
}
</style>
